import { schema } from 'normalizr';

const domainGroup = new schema.Entity( 'domainGroups' );

const domain = new schema.Entity( 'domains', {
    domainGroups: [domainGroup],
}, {
    idAttribute: ( value ) => value.domainName,
} );

const notes = new schema.Entity( 'notes', {
    idAttribute: 'id'
} );

export const domainsSchema = [ domain ];
export const domainNotesSchema = [ notes ];
